import React, { Component } from "react";
import "@assets/css/Pages/error-boundary.css";
import LogoAltee from "@assets/img/logoAltee.svg";
import {
  UncontrolledCollapse
} from 'reactstrap'
export default class pageErreur400 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      errorInfo: "",
      logsError: {},
    };
  }
  static getDerivedStateFromError(error) {
    if (error.toString()) {
      return {
        hasError: true
      }
    }
  }
  componentDidCatch(error, info) {
    this.setState({
      errorInfo: error, //"Permission" : ObjectId("600f06b6e8b7a3363cc09f1f"),
      logsError: info,
    });
  }
  render() {
    let { errorInfo, hasError, logsError } = this.state
    if (hasError) {

      return (
        <>
          <div className="errorPage_container">
            <div className="d-flex flex-justify-center logo_Altee w-100">
              <img src={LogoAltee} alt="logoAltee" />
            </div>
            <div className="d-flex flex-justify-center w-100">
              <span className="bold number_error">Oops ! </span>
            </div>
            <div className="d-flex flex-justify-center w-100">
              <span className="semibold error_description">
                Something went wrong
              </span>
            </div>
            <div className="d-flex flex-column ">
              <div className="semibold error_logs text-center mt-2">
                <span id="accordionError">Click here to show error</span>
                <UncontrolledCollapse toggler="#accordionError">
                  <div className="panel_course">
                    <span className="description_course GreenThemeSelect regular">
                      {errorInfo.toString()}
                    </span>
                  </div>
                </UncontrolledCollapse>
              </div>
              <div className="semibold error_logs text-center mt-2">
                <span id="accordionDetails">Click here to show details</span>
                <UncontrolledCollapse toggler="#accordionDetails">
                  <div className="panel_course">
                    <span className="description_course GreenThemeSelect regular">
                      {logsError?.componentStack}
                    </span>
                  </div>
                </UncontrolledCollapse>
              </div>
            </div>
          </div>
        </>
      );
    }
    return this.props.children;
  }
}
